module.exports = __webpack_public_path__ + "img/user-default.31316905.jpg";